import { Form } from 'factorial-form'

class EmployeeContactForm extends Form {
  constructor(values: Record<string, string>) {
    super(values, {
      contact_name: 'string',
      contact_number: 'string',
    })
  }
}

export default EmployeeContactForm
